import React, { FC, ReactNode, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContext } from '../../../user/UserContext';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = {
  list: Array<any>;
  limit: number;
  children: (array: Array<any>) => ReactNode;
  source: string;
};

export const EntityRestrictedList: FC<Props> = ({
  list,
  limit,
  children,
  source,
}) => {
  const { loggedIn } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();
  if (loggedIn || limit >= list.length) {
    return <>{children(list)}</>;
  }
  const newList = list.slice(0, limit);
  return (
    <>
      {children(newList)}
      <span
        onClick={() => openRestrictedModal({ source: `${source}_see_more` })}
        className="entity__see-more entity__link-color vertical-align-elements pointer"
      >
        <FormattedMessage
          id="entity/expertises/RestrictedList.tsx/1"
          values={{ number: list.length - limit }}
        />{' '}
        <MaterialIcon name="keyboard_arrow_down" />
      </span>
    </>
  );
};
